import {derived} from 'svelte/store';
import {page} from '$app/stores';
import {interpret} from 'xstate';

import type {Readable} from 'svelte/store';

import {machine} from '$lib/machines/service-providers';

import {authService} from './auth';
import {EventType as AuthEventType} from '$lib/machines/auth';

import type {ServiceProvider} from '$types/entities/service-provider';

const serviceProviderService = interpret(machine).start();

authService.onEvent((event) => {
  const {type} = event;

  if (type === AuthEventType.IdentityLogin) {
    serviceProviderService.send('GET');
  }
});

type ServiceProviderStore = Readable<ServiceProvider | undefined>;

const activeServiceProvider: ServiceProviderStore = derived(
  [page, serviceProviderService as unknown as Readable<typeof machine>],
  ([$page, $serviceProviderStore]) => {
    const {serviceProviderId} = $page.params;
    const serviceProvider = serviceProviderId
      ? $serviceProviderStore.context.items.find(
          (serviceProvider: ServiceProvider) =>
            serviceProvider.sys.id === serviceProviderId,
        )
      : undefined;

    return serviceProvider;
  },
);

const mostRecentServiceProvider: ServiceProviderStore = derived(
  activeServiceProvider,
  ($serviceProvider, set) => {
    if ($serviceProvider) {
      set($serviceProvider);
    }
  },
);

export {
  activeServiceProvider,
  serviceProviderService,
  mostRecentServiceProvider,
};
